/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { RemoveStaffMemberMutationResponse, RemoveStaffMemberPathParams, RemoveStaffMember400, RemoveStaffMember401, RemoveStaffMember403, RemoveStaffMember404, RemoveStaffMember409, RemoveStaffMember500 } from "../../types/staffController/RemoveStaffMember.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getRemoveStaffMemberUrl(organizationId: RemoveStaffMemberPathParams["organizationId"], staffId: RemoveStaffMemberPathParams["staffId"]) {
  const res = { method: 'DELETE', url: `/api/organizations/${organizationId}/staff/${staffId}` as const }
  return res
}

/**
 * @summary Remove staff member
 * {@link /api/organizations/:organizationId/staff/:staffId}
 */
export async function removeStaffMember(organizationId: RemoveStaffMemberPathParams["organizationId"], staffId: RemoveStaffMemberPathParams["staffId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<RemoveStaffMemberMutationResponse, ResponseErrorConfig<RemoveStaffMember400 | RemoveStaffMember401 | RemoveStaffMember403 | RemoveStaffMember404 | RemoveStaffMember409 | RemoveStaffMember500>, unknown>({ method : "DELETE", url : getRemoveStaffMemberUrl(organizationId, staffId).url.toString(), ... requestConfig })
  return res.data
}